import { render, staticRenderFns } from "./ProcessEditorList.vue?vue&type=template&id=581c6211&"
import script from "./ProcessEditorList.vue?vue&type=script&lang=js&"
export * from "./ProcessEditorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports